import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-performance-audit-display-manual',
    template: `
        <mon-markdown-viewer [monMarkdown]="audit.description"></mon-markdown-viewer>
    `,
    standalone: false,
})
export class PagePerformanceAuditDisplayManualComponent {
    @Input() audit: any;

    constructor () {
    }
}
